import "./CallAndAsk.scss";
import { useTranslation } from "react-i18next";

export default function CallAndAsk() {
  const { t } = useTranslation();
  const deviceType = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    ? "mobile"
    : "desktop";
  return (
    <div className="call-and-ask">
      <div className="content">
        <div className="left">
          <div className="text">
            <p>{t("call-and-ask")}</p>
          </div>
          <div className="cta">
            <a
              href={
                deviceType === "desktop"
                  ? "mailto:dragalevtsi@alexfish.bg"
                  : "tel:+359885777310"
              }
            >
              {t("contact-now")}
            </a>
          </div>
        </div>
        <div className="middle"></div>
        <div className="right"></div>
      </div>
    </div>
  );
}
